'use strict';

var _constant = require('./constant');

var _constant2 = _interopRequireDefault(_constant);

var _core = require('./core');

var _core2 = _interopRequireDefault(_core);

require('./suisdk');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 通信功能方法

// 挂载sui到winodw上
window.sui = _constant2.default;

// 引入sdk默认方法


// 返回客户端可支持api列表
_core2.default.getSupport();